export default "icons-settings"